"use client";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button, buttonVariants } from "@/components/ui/button";
import { useEffect, useState } from "react";
import GetInTouchForm from "../forms/get-in-touch-form";
import { Phone, XIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export function PopUpForm({ destination, showTrigger = true }: { destination?: string, showTrigger?: boolean }) {
  const [isOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsDialogOpen(true);
    }, 30000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsDialogOpen}>
      {showTrigger && (
        <AlertDialogTrigger >
          <Button
            variant={"outline"}
            className="font-md flex h-11 items-center justify-center font-semibold text-sm sm:text-base hover:bg-black group hover:text-white mx-auto w-full border-[1.5px] border-black bg-white text-black"
          >
            Enquiry <Phone className="  group-hover:fill-white fill-black" strokeWidth={0} />
          </Button>
        </AlertDialogTrigger>
      )}
      <AlertDialogContent className="pb-2">
        <AlertDialogHeader>
          <div className="flex w-full items-start">
            <AlertDialogTitle className="text-2xl font-semibold font-lexend">
              Fill out the form and our team will contact you soon....
            </AlertDialogTitle>
            <button onClick={() => setIsDialogOpen(false)} className={cn(buttonVariants({ variant: "default" }), "rounded shrink-0 size-8 absolute top-1 right-1")}>
              <XIcon />
            </button>
          </div>
          <AlertDialogDescription className="">
            <div className="mx-auto w-full">
              <GetInTouchForm destination={destination} note />
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
      </AlertDialogContent>
    </AlertDialog>
  );
}
